import {CellRange} from './cell_range';
// operator: all|eq|neq|gt|gte|lt|lte|in|be
// value:
//   in => []
//   be => [min, max]
const column = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'AA', 'AB', 'AC', 'AD', 'AE', 'AF', 'AG', 'AH', 'AI', 'AJ', 'AK', 'AL', 'AM', 'AN', 'AO', 'AP', 'AQ', 'AR', 'AS', 'AT', 'AU', 'AV', 'AW', 'AX', 'AY', 'AZ', 'BA', 'BB', 'BC', 'BD', 'BE', 'BF', 'BG', 'BH', 'BI', 'BJ', 'BK', 'BL', 'BM', 'BN', 'BO', 'BP', 'BQ', 'BR', 'BS', 'BT', 'BU', 'BV', 'BW', 'BX', 'BY', 'BZ', 'CA', 'CB', 'CC', 'CD', 'CE', 'CF', 'CG', 'CH', 'CI', 'CJ', 'CK', 'CL', 'CM', 'CN', 'CO', 'CP', 'CQ', 'CR', 'CS', 'CT', 'CU', 'CV', 'CW', 'CX', 'CY', 'CZ', 'DA', 'DB', 'DC', 'DD', 'DE', 'DF', 'DG', 'DH', 'DI', 'DJ', 'DK', 'DL', 'DM', 'DN', 'DO', 'DP', 'DQ', 'DR', 'DS', 'DT', 'DU', 'DV', 'DW', 'DX', 'DY', 'DZ', 'EA', 'EB', 'EC', 'ED', 'EE', 'EF', 'EG', 'EH', 'EI', 'EJ', 'EK', 'EL', 'EM', 'EN', 'EO', 'EP', 'EQ', 'ER', 'ES', 'ET', 'EU', 'EV', 'EW', 'EX', 'EY', 'EZ', 'FA', 'FB', 'FC', 'FD', 'FE', 'FF', 'FG', 'FH', 'FI', 'FJ', 'FK', 'FL', 'FM', 'FN', 'FO', 'FP', 'FQ', 'FR', 'FS', 'FT', 'FU', 'FV', 'FW', 'FX', 'FY', 'FZ', 'GA', 'GB', 'GC', 'GD', 'GE', 'GF', 'GG', 'GH', 'GI', 'GJ', 'GK', 'GL', 'GM', 'GN', 'GO', 'GP', 'GQ', 'GR', 'GS', 'GT', 'GU', 'GV', 'GW', 'GX', 'GY', 'GZ', 'HA', 'HB', 'HC', 'HD', 'HE', 'HF', 'HG', 'HH', 'HI', 'HJ', 'HK', 'HL', 'HM', 'HN', 'HO', 'HP', 'HQ', 'HR', 'HS', 'HT', 'HU', 'HV', 'HW', 'HX', 'HY', 'HZ', 'IA', 'IB', 'IC', 'ID', 'IE', 'IF', 'IG', 'IH', 'II', 'IJ', 'IK', 'IL', 'IM', 'IN', 'IO', 'IP', 'IQ', 'IR', 'IS', 'IT', 'IU', 'IV', 'IW', 'IX', 'IY', 'IZ', 'JA', 'JB', 'JC', 'JD', 'JE', 'JF', 'JG', 'JH', 'JI', 'JJ', 'JK', 'JL', 'JM', 'JN', 'JO', 'JP', 'JQ', 'JR', 'JS', 'JT', 'JU', 'JV', 'JW', 'JX', 'JY', 'JZ', 'KA', 'KB', 'KC', 'KD', 'KE', 'KF', 'KG', 'KH', 'KI', 'KJ', 'KK', 'KL', 'KM', 'KN', 'KO', 'KP', 'KQ', 'KR', 'KS', 'KT', 'KU', 'KV', 'KW', 'KX', 'KY', 'KZ', 'LA', 'LB', 'LC', 'LD', 'LE', 'LF', 'LG', 'LH', 'LI', 'LJ', 'LK', 'LL', 'LM', 'LN', 'LO', 'LP', 'LQ', 'LR', 'LS', 'LT', 'LU', 'LV', 'LW', 'LX', 'LY', 'LZ', 'MA', 'MB', 'MC', 'MD', 'ME', 'MF', 'MG', 'MH', 'MI', 'MJ', 'MK', 'ML', 'MM', 'MN', 'MO', 'MP', 'MQ', 'MR', 'MS', 'MT', 'MU', 'MV', 'MW', 'MX', 'MY', 'MZ', 'NA', 'NB', 'NC', 'ND', 'NE', 'NF', 'NG', 'NH', 'NI', 'NJ', 'NK', 'NL', 'NM', 'NN', 'NO', 'NP', 'NQ', 'NR', 'NS', 'NT', 'NU', 'NV', 'NW', 'NX', 'NY', 'NZ', 'OA', 'OB', 'OC', 'OD', 'OE', 'OF', 'OG', 'OH', 'OI', 'OJ', 'OK', 'OL', 'OM', 'ON', 'OO', 'OP', 'OQ', 'OR', 'OS', 'OT', 'OU', 'OV', 'OW', 'OX', 'OY', 'OZ', 'PA', 'PB', 'PC', 'PD', 'PE', 'PF', 'PG', 'PH', 'PI', 'PJ', 'PK', 'PL', 'PM', 'PN', 'PO', 'PP', 'PQ', 'PR', 'PS', 'PT', 'PU', 'PV', 'PW', 'PX', 'PY', 'PZ', 'QA', 'QB', 'QC', 'QD', 'QE', 'QF', 'QG', 'QH', 'QI', 'QJ', 'QK', 'QL', 'QM', 'QN', 'QO', 'QP', 'QQ', 'QR', 'QS', 'QT', 'QU', 'QV', 'QW', 'QX', 'QY', 'QZ', 'RA', 'RB', 'RC', 'RD', 'RE', 'RF', 'RG', 'RH', 'RI', 'RJ', 'RK', 'RL', 'RM', 'RN', 'RO', 'RP', 'RQ', 'RR', 'RS', 'RT', 'RU', 'RV', 'RW', 'RX', 'RY', 'RZ', 'SA', 'SB', 'SC', 'SD', 'SE', 'SF', 'SG', 'SH', 'SI', 'SJ', 'SK', 'SL', 'SM', 'SN', 'SO', 'SP', 'SQ', 'SR', 'SS', 'ST', 'SU', 'SV', 'SW', 'SX', 'SY', 'SZ', 'TA', 'TB', 'TC', 'TD', 'TE', 'TF', 'TG', 'TH', 'TI', 'TJ', 'TK', 'TL', 'TM', 'TN', 'TO', 'TP', 'TQ', 'TR', 'TS', 'TT', 'TU', 'TV', 'TW', 'TX', 'TY', 'TZ', 'UA', 'UB', 'UC', 'UD', 'UE', 'UF', 'UG', 'UH', 'UI', 'UJ', 'UK', 'UL', 'UM', 'UN', 'UO', 'UP', 'UQ', 'UR', 'US', 'UT', 'UU', 'UV', 'UW', 'UX', 'UY', 'UZ', 'VA', 'VB', 'VC', 'VD', 'VE', 'VF', 'VG', 'VH', 'VI', 'VJ', 'VK', 'VL', 'VM', 'VN', 'VO', 'VP', 'VQ', 'VR', 'VS', 'VT', 'VU', 'VV', 'VW', 'VX', 'VY', 'VZ', 'WA', 'WB', 'WC', 'WD', 'WE', 'WF', 'WG', 'WH', 'WI', 'WJ', 'WK', 'WL', 'WM', 'WN', 'WO', 'WP', 'WQ'];


    class Filter {
    constructor(ci, operator, value) {
        this.ci = ci;
        this.operator = operator;
        this.value = value;
    }

    set(operator, value) {
        this.operator = operator;
        this.value = value;
    }

    includes(v) {
        const {operator, value} = this;
        if (operator === 'all') {
            return true;
        }
        if (operator === 'in') {
            return value.includes(v);
        }
        return false;
    }

    vlength() {
        const {operator, value} = this;
        if (operator === 'in') {
            return value.length;
        }
        return 0;
    }

    getData() {
        const {ci, operator, value} = this;
        return {ci, operator, value};
    }
}

class Sort {
    constructor(ci, order) {
        this.ci = ci;
        this.order = order;
    }

    asc() {
        return this.order === 'asc';
    }

    desc() {
        return this.order === 'desc';
    }
}

export default class AutoFilter {
    constructor(rows, cols) {
        this.rows = rows;
        this.cols = cols;
        this.ref = null;
        this.filters = [];
        this.sort = null;
    }

    setData({ref, filters, sort}) {
        if (ref != null) {
            this.ref = ref;
            this.filters = filters.map(it => new Filter(it.ci, it.operator, it.value));
            if (sort) {
                this.sort = new Sort(sort.ci, sort.order);
            }
        }
    }

    getData() {
        if (this.active()) {
            this.ref = "A1:" + column[this.cols - 1] + (this.rows - 1);
            let {ref, filters, sort} = this;
            return {ref, filters: filters.map(it => it.getData()), sort};
        }
        return {};
    }

    addFilter(ci, operator, value) {
        const filter = this.getFilter(ci);
        if (filter == null) {
            this.filters.push(new Filter(ci, operator, value));
        } else {
            filter.set(operator, value);
        }
    }

    setSort(ci, order) {
        this.sort = order ? new Sort(ci, order) : null;
    }

    includes(ri, ci) {
        if (this.active()) {
            return this.hrange().includes(ri, ci);
        }
        return false;
    }

    getSort(ci) {
        const {sort} = this;
        if (sort && sort.ci === ci) {
            return sort;
        }
        return null;
    }

    getFilter(ci) {
        const {filters} = this;
        for (let i = 0; i < filters.length; i += 1) {
            if (filters[i].ci === ci) {
                return filters[i];
            }
        }
        return null;
    }

    filteredRows(getCell) {
        // const ary = [];
        // let lastri = 0;
        const rset = new Set();
        const fset = new Set();
        if (this.active()) {
            const {sri, eri} = this.range();
            const {filters} = this;
            for (let ri = sri + 1; ri <= eri; ri += 1) {
                for (let i = 0; i < filters.length; i += 1) {
                    const filter = filters[i];
                    const cell = getCell(ri, filter.ci);
                    if (!cell || cell && !filter.includes(cell.text)) {
                        rset.add(ri);
                        break;
                    } else {
                        fset.add(ri);
                    }
                }
            }
        }
        return {rset, fset};
    }

    items(ci, getCell) {
        const m = {};
        if (this.active()) {
            const {sri, eri} = this.range();
            for (let ri = sri + 1; ri <= eri; ri += 1) {
                const cell = getCell(ri, ci);
                if (cell !== null && !/^\s*$/.test(cell.text)) {
                    const key = cell.text;
                    const cnt = (m[key] || 0) + 1;
                    m[key] = cnt;
                } else {
                    m[''] = (m[''] || 0) + 1;
                }
            }
        }
        return m;
    }

    range() {
        return CellRange.valueOf(this.ref);
    }

    hrange() {
        const r = this.range();
        r.eri = r.sri;
        return r;
    }

    clear() {
        this.ref = null;
        this.filters = [];
        this.sort = null;
    }

    active() {
        return this.ref !== null;
    }
}
